var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Aspect',{attrs:{"type":"always","span":"8.5","name":"六个如何始终"}})}
var staticRenderFns = []

export { render, staticRenderFns }